export type ConditionType =
  | 'always'
  | 'time_of_day'
  | 'date_range'
  | 'start_weekday'
  | 'end_weekday'
  | 'duration_days'
  | 'duration_minutes'
  | 'advance_booking'
  | 'days_from_start'
  | 'voucher'
  | 'allowed_emails'
  | 'user_role'
  | 'logged_in';

export type UpdateType = 'override' | 'increase' | 'discount';
export type ValueKind = 'amount' | 'percentage';
export type RateUnit =
  | 'per_hour'
  | 'per_day'
  | 'per_week'
  | 'per_month'
  | 'per_reservation'
  | 'fixed';

// condition_params is a discriminated object carrying `type` === condition_type
export type ConditionParams = { type: ConditionType } & Record<string, unknown>;

export interface PricingRule {
  name: string | null;
  enabled: boolean;
  order: number;
  condition_type: ConditionType;
  condition_params: ConditionParams;
  update_type: UpdateType;
  value: number; // minor units (amount) or percentage
  value_kind: ValueKind;
  unit: RateUnit | null;
  voucher_ids: string[];
  allowed_emails: string[];
}

export interface PricingTemplateForm {
  name: string;
  description: string | null;
  base_price_per_day_minor?: number;
  base_price_per_hour_minor?: number;
  min_rental_minutes: number | null;
  min_rental_days: number | null;
  valid_from: string | null;
  valid_to: string | null;
  status: 'active' | 'inactive';
  pricing_rules: PricingRule[];
  currency_symbol?: string;
}

export const CONDITION_TYPES: ConditionType[] = [
  'always',
  'time_of_day',
  'date_range',
  'start_weekday',
  'end_weekday',
  'duration_days',
  'duration_minutes',
  'advance_booking',
  'days_from_start',
  'voucher',
  'allowed_emails',
  'user_role',
  'logged_in',
];

export const RATE_UNITS: RateUnit[] = [
  'per_hour',
  'per_day',
  'per_week',
  'per_month',
  'per_reservation',
  'fixed',
];

export const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; // 0=Sun..6=Sat

export function emptyRule(order: number): PricingRule {
  return {
    name: '',
    enabled: true,
    order,
    condition_type: 'always',
    condition_params: { type: 'always' },
    update_type: 'override',
    value: 0,
    value_kind: 'amount',
    unit: 'per_day',
    voucher_ids: [],
    allowed_emails: [],
  };
}
